import { useEffect } from "react";

export const VentureForm = () => {
   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: '366265ca-342e-48bb-a0f8-015c59cbbeee',
               target: '#ventureForm'
            })
         }
      });
   });

   return (
      <div className="footer-form txt-start venture-form">
         <h1>To Apply:</h1>
         <p>Make a post on Twitter with why you think you should be selected and include the following: #venturenurturing #VSW24 @youngstartupven.</p>
         <p>Suggestion: Include a 60 second video of your elevator pitch in your tweet.</p>
         <p>Fill out the form below</p>
         <div id="ventureForm" />
      </div>
   )
}